module.exports = __webpack_public_path__ + "static/img/mondoconnex-menu-logo.ec08d2b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mondoconnex-menu-logo.svg
// module id = 32
// module chunks = 14